export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['org', 'city2', 'country2', 'city3', 'state3', 'country3'],
    properties: {
      org: {
        title: 'Name of Organization',
        type: 'string',
        maxLength: 20,
        minLength: 10
      },
      scope: {
        title: 'Scope of Organization',
        type: 'string',
        enum: ['Local', 'State', 'Regional', 'National', 'International'],
        enumNames: ['Local', 'State', 'Regional', 'National', 'International']
      },
      city1: {
        title: 'City',
        type: 'string'
      },
      state1: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country1: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      city2: {
        title: 'City',
        type: 'string'
      },
      state2: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country2: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      city3: {
        title: 'City',
        type: 'string'
      },
      state3: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country3: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      city4: {
        title: 'City',
        type: 'string'
      },
      state4: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country4: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      city5: {
        title: 'City',
        type: 'string'
      },
      state5: {
        title: 'State',
        type: 'string',
        enum: ['WI', 'Other'],
        enumNames: ['WI', 'Other']
      },
      country5: {
        title: 'Country',
        type: 'string',
        enum: ['USA', 'Other'],
        enumNames: ['USA', 'Other']
      },
      longQuestion1: {
        title: 'Question 1',
        type: 'string'
      },
      longQuestion2: {
        title: 'Question 2',
        type: 'string'
      },
      longQuestion3: {
        title: 'Question 3',
        type: 'string'
      },
      longQuestion4: {
        title: 'Question 4',
        type: 'string'
      },
      longQuestion5: {
        title: 'Question 5',
        type: 'string'
      },
      longQuestion6: {
        title: 'Question 6',
        type: 'string'
      },
      longQuestion7: {
        title: 'Question 7',
        type: 'string'
      },
      longQuestion8: {
        title: 'Question 8',
        type: 'string'
      },
      ophone1: {
        title: 'Office Phone Area Code',
        type: 'integer'
      },
      ophone2: {
        title: 'Office Phone Prefix',
        type: 'integer'
      },
      ophone3: {
        title: 'Office Phone Suffix',
        type: 'integer'
      },
      ophone4: {
        title: 'Office Phone Extension',
        type: 'integer'
      },
      startMonth: {
        title: 'Start Month Start Month Start Month Start Month Start Month Start Month Start Month Start Month Start Month Start Month Start Month Start Month ',
        type: 'string',
        enum: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      startDay: {
        title: 'Day',
        type: 'integer',
        minimum: 1,
        maximum: 31
      },
      startYear: {
        title: 'Year',
        type: 'integer',
        minimum: 1900,
        maximum: 2100
      },
      endMonth: {
        title: 'Month',
        type: 'string',
        enum: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      endDay: {
        title: 'Day',
        type: 'integer',
        minimum: 1,
        maximum: 31
      },
      endYear: {
        title: 'Year',
        type: 'integer',
        minimum: 1900,
        maximum: 2100
      }
    }
  },
  uiSchema: {
    org: {
      'ui:widget': 'text',
      'ui:help': 'Some help text'
    },
    scope: {
      'ui:widget': 'select'
    },
    city1: {
      'ui:widget': 'text'
    },
    state1: {
      'ui:widget': 'select'
    },
    110001: {
      'ui:title': ','
    },
    country1: {
      'ui:widget': 'select'
    },
    group_1123456: {
      'ui:title': {
        text: '<div>City, State</div> and Country 1 with a block element and lots of text in this label you know what Im saying?',
        escape: false
      }
    },
    city2: {
      'ui:widget': 'text'
    },
    state2: {
      'ui:widget': 'select'
    },
    210001: {
      'ui:title': ','
    },
    country2: {
      'ui:widget': 'select',
      'ui:help': {
        text: 'Help text on child question',
        escape: false
      }
    },
    group_2123456: {
      'ui:title': 'City, State and Country 2',
      'ui:options': {
        icons: ['READ_ONLY']
      }
    },
    city3: {
      'ui:widget': 'text'
    },
    state3: {
      'ui:widget': 'select'
    },
    310001: {
      'ui:title': ','
    },
    country3: {
      'ui:widget': 'select',
      'ui:help': {
        text: 'Help text on child question',
        escape: false
      }
    },
    group_3123456: {
      'ui:title': 'City, State and Country 3',
      'ui:options': {
        icons: ['READ_ONLY']
      },
      'ui:help': {
        text: 'Help text on question group',
        escape: false
      }
    },
    city4: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['READ_ONLY']
      }
    },
    state4: {
      'ui:widget': 'select',
      'ui:options': {
        icons: ['READ_ONLY']
      }
    },
    410001: {
      'ui:title': ','
    },
    country4: {
      'ui:widget': 'select',
      'ui:options': {
        icons: ['READ_ONLY']
      },
      'ui:help': {
        text: 'Help text on child question',
        escape: false
      }
    },
    group_4123456: {
      'ui:title': 'City, State and Country 4',
      'ui:options': {
        icons: ['READ_ONLY']
      },
      'ui:help': {
        text: 'Help text on question group',
        escape: false
      }
    },
    city5: {
      'ui:widget': 'text',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'HIDDEN']
      }
    },
    state5: {
      'ui:widget': 'select',
      'ui:options': {
        icons: ['PUBLICLY_AVAILABLE', 'READ_ONLY']
      }
    },
    510001: {
      'ui:title': ','
    },
    country5: {
      'ui:widget': 'select',
      'ui:help': {
        text: 'Help text on child question',
        escape: false
      }
    },
    group_5123456: {
      'ui:title': 'City, State and Country 5',
      'ui:help': {
        text: 'Help text on question group',
        escape: false
      }
    },
    longQuestion1: {
      'ui:widget': 'text'
    },
    longQuestion2: {
      'ui:widget': 'text'
    },
    longQuestion3: {
      'ui:widget': 'text'
    },
    longQuestion4: {
      'ui:widget': 'text'
    },
    longQuestion5: {
      'ui:widget': 'text'
    },
    longQuestion6: {
      'ui:widget': 'text'
    },
    longQuestion7: {
      'ui:widget': 'text'
    },
    longQuestion8: {
      'ui:widget': 'text'
    },
    group_A123456: {
      'ui:title': 'Large Question Group'
    },
    ophone1: {
      'ui:widget': 'text'
    },
    ophoneSeparator1: {
      'ui:title': '-'
    },
    ophone2: {
      'ui:widget': 'text'
    },
    ophoneSeparator2: {
      'ui:title': '-'
    },
    ophone3: {
      'ui:widget': 'text'
    },
    ophoneSeparator3: {
      'ui:title': 'x'
    },
    ophone4: {
      'ui:widget': 'text'
    },
    group_ophone: {
      'ui:title': 'Office Phone'
    },
    startMonth: {
      'ui:widget': 'select'
    },
    startDay: {
      'ui:widget': 'text'
    },
    startComma: {
      'ui:title': ','
    },
    startYear: {
      'ui:widget': 'text'
    },
    group_startDate: {
      'ui:title': 'Start Date',
      'ui:options': {
        compact: true
      }
    },
    endMonth: {
      'ui:widget': 'select'
    },
    endDay: {
      'ui:widget': 'text'
    },
    endComma: {
      'ui:title': ','
    },
    endYear: {
      'ui:widget': 'text'
    },
    group_endDate: {
      'ui:title': 'End Date',
      'ui:options': {
        compact: true
      }
    },
    'dm:layout': [{
      type: 'field',
      id: 'org'
    }, {
      id: 'group_1123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city1'
      }, {
        type: 'field',
        id: 'state1'
      }, {
        type: 'text',
        id: '110001'
      }, {
        type: 'field',
        id: 'country1'
      }]
    }, {
      id: 'group_2123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city2'
      }, {
        type: 'field',
        id: 'state2'
      }, {
        type: 'text',
        id: '210001'
      }, {
        type: 'field',
        id: 'country2'
      }]
    }, {
      id: 'group_3123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city3'
      }, {
        type: 'field',
        id: 'state3'
      }, {
        type: 'text',
        id: '310001'
      }, {
        type: 'field',
        id: 'country3'
      }]
    }, {
      id: 'group_4123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city4'
      }, {
        type: 'field',
        id: 'state4'
      }, {
        type: 'text',
        id: '410001'
      }, {
        type: 'field',
        id: 'country4'
      }]
    }, {
      id: 'group_5123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'city5'
      }, {
        type: 'field',
        id: 'state5'
      }, {
        type: 'text',
        id: '510001'
      }, {
        type: 'field',
        id: 'country5'
      }]
    }, {
      id: 'group_A123456',
      type: 'group',
      children: [{
        type: 'field',
        id: 'longQuestion1'
      }, {
        type: 'field',
        id: 'longQuestion2'
      }, {
        type: 'field',
        id: 'longQuestion3'
      }, {
        type: 'field',
        id: 'longQuestion4'
      }, {
        type: 'field',
        id: 'longQuestion5'
      }, {
        type: 'field',
        id: 'longQuestion6'
      }, {
        type: 'field',
        id: 'longQuestion7'
      }, {
        type: 'field',
        id: 'longQuestion8'
      }]
    }, {
      id: 'group_ophone',
      type: 'group',
      children: [{
        type: 'field',
        id: 'ophone1'
      }, {
        type: 'text',
        id: 'ophoneSeparator1'
      }, {
        type: 'field',
        id: 'ophone2'
      }, {
        type: 'text',
        id: 'ophoneSeparator2'
      }, {
        type: 'field',
        id: 'ophone3'
      }, {
        type: 'text',
        id: 'ophoneSeparator3'
      }, {
        type: 'field',
        id: 'ophone4'
      }]
    }, {
      id: 'group_startDate',
      type: 'group',
      children: [{
        type: 'field',
        id: 'startMonth'
      }, {
        type: 'field',
        id: 'startDay'
      }, {
        type: 'text',
        id: 'startComma'
      }, {
        type: 'field',
        id: 'startYear'
      }]
    }, {
      id: 'group_endDate',
      type: 'group',
      children: [{
        type: 'field',
        id: 'endMonth'
      }, {
        type: 'field',
        id: 'endDay'
      }, {
        type: 'text',
        id: 'endComma'
      }, {
        type: 'field',
        id: 'endYear'
      }]
    }, {
      type: 'field',
      id: 'scope'
    }]
  },
  formData: {}
};